import { useState } from "react";
import { Stack } from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { TableCustomProps } from "../../../components/table/table";
import TableMaterial from "../../../components/tableMaterial/tableMaterial";
import ButtonUI from "../../../components/button/buttons";
import ModalUI from "../../../components/modalUI/ModalUI";
import CreateFormAccount from "./createAccount";
import useFetchAccountsBank from "../../../service/userBankAccount/getUserAccountBank";
import {
  getAccountTypeDescription,
  getBank,
} from "../../../components/utils/typeAccount";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DeleteAccountBankModal } from "./deleteAccountBankModal";
import { tokenToString } from "typescript";
import SnackBar from "../../../components/notification/snackbar/snackbar";
import { CardInfo } from "../../../components/common/cardInfo/CardInfo";

const Accounts = () => {
  const storedToken = sessionStorage.getItem("userData");
  const [page, setPage] = useState(1);

  const [openModal, setOpenModal] = useState(false);
  const [modalType, setModalType] = useState<string>("");
  const [dataAccountBank, setDataAccountBank] = useState<string>("");
  const [notification, setNotification] = useState({
    open: false,
    message: "",
    severity: "info" as "success" | "info" | "warning" | "error",
  });

  const [notificationAdd, setNotificationAdd] = useState({
    open: false,
    message: "",
    severity: "info" as "success" | "info" | "warning" | "error",
  });

  const { accountsBank, loading, refresh } = useFetchAccountsBank(
    storedToken || ""
  );

  const handleClose = () => {
    setNotification((prev) => ({ ...prev, open: false }));
    setNotificationAdd((prev) => ({ ...prev, open: false }));
  };

  const modalOnclick = (type: string, data?: any) => {
    setDataAccountBank(data);
    setOpenModal(true);
    setModalType(type);
  };

  const transformDataToTable = (
    transferences: any[]
  ): TableCustomProps["rows"] => {
    return transferences?.map((transaction) => ({
      name: transaction.name,
      type: getAccountTypeDescription(transaction.type_of_account),
      clabe: transaction.account_number,
      bank: getBank(transaction.code_bank),
      date: new Date(transaction?.created_at).toLocaleDateString("es-MX", {
        year: "numeric",
        month: "numeric",
        day: "numeric",
      }),

      delete: (
        <div>
          <ButtonUI
            icon={<FontAwesomeIcon icon={faTrash} />}
            onClick={() => modalOnclick("remove", transaction.account_number)}
            color="warning"
          />
        </div>
      ),
    }));
  };

  const dataTable: any = {
    columns: [
      { id: "name", label: "Nombre" },
      { id: "type", label: "Tipo de cuenta" },
      { id: "bank", label: "Banco" },
      { id: "clabe", label: "Cuenta" },
      { id: "date", label: "Fecha" },
      { id: "delete", label: "Remover" },
    ],
    rows: transformDataToTable(accountsBank?.data ?? []),
  };

  const hasData = dataTable?.rows?.length > 0 && [];

  return (
    <div>
      <div>
        <h2>Cuentas Bancarias</h2>
        <CardInfo message="Añade los datos de tu cuenta y, una vez guardada, estará disponible para recibir el saldo que hayas solicitado. Es un proceso rápido y seguro para que tu dinero llegue a donde debe." />
        <Stack spacing={2} direction="row">
          <ButtonUI
            icon={<AddCircleOutlineIcon />}
            onClick={() => modalOnclick("add")}
            size="small"
            color="primary"
            variant="outlined"
            title="Agregar cuenta"
          />
          {/* <AccountFormulary></AccountFormulary> */}
        </Stack>
        <TableMaterial
          isSearch={false}
          rowsPerPage={1}
          page={1}
          setPage={setPage}
          totalRows={5}
          loading={loading}
          columns={dataTable?.columns}
          rows={dataTable?.rows}
        />
      </div>
      <ModalUI
        setOpen={setOpenModal}
        open={openModal}
        children={
          modalType === "add" ? (
            <CreateFormAccount
              refresh={refresh}
              setNotification={setNotificationAdd}
              authToken={storedToken}
              setOpenModal={setOpenModal}
            />
          ) : (
            <DeleteAccountBankModal
              refresh={refresh}
              setModalNotification={setNotification}
              data={dataAccountBank}
              setOpenModal={setOpenModal}
              authToken={storedToken}
            />
          )
        }
      />
      <SnackBar
        open={notificationAdd.open}
        message={notificationAdd.message}
        severity={notificationAdd.severity}
        onClose={handleClose}
      />
      <SnackBar
        open={notification.open}
        message={notification.message}
        severity={notification.severity}
        onClose={handleClose}
      />
    </div>
  );
};

export default Accounts;
